// Leave the first-screen images, styles and fonts ahead of background media.
// Two animation frames give the loaded page a paint before starting the work.
export function afterPagePaint(callback, environment = window) {
  const document = environment.document;
  let cancelled = false;
  let frame;
  const run = () => {
    if (!cancelled) callback();
  };
  const schedule = () => {
    if (cancelled) return;
    frame = environment.requestAnimationFrame(() => {
      if (!cancelled) frame = environment.requestAnimationFrame(run);
    });
  };
  if (document.readyState === 'complete') schedule();
  else environment.addEventListener('load', schedule, { once: true });
  return () => {
    cancelled = true;
    environment.removeEventListener('load', schedule);
    if (frame !== undefined) environment.cancelAnimationFrame(frame);
  };
}
